import React from "react";
import { ExpandedRowDetails } from "../../../ui";
import { generateOverrideId } from "../../../utils";
import { PolicyRecommendation } from "../../common";
import IssueOverrideComponentList from "./IssueOverrideComponentList";
const IssueDetails = ({ issue }) => {
    // Ensures effort updates with filters and that files from disabled policies are not counted
    // No need to memo since there can be at most 3 overrides
    const fileCount = issue.overrides.reduce((acc, override) => override.enabled ? acc + override.component_count : acc, 0);
    return (React.createElement(ExpandedRowDetails, null,
        React.createElement(ExpandedRowDetails.Aside, null,
            React.createElement(PolicyRecommendation, { recommendation: issue.recommendation, effort: issue.effort, violationCount: fileCount })),
        React.createElement(ExpandedRowDetails.Main, null, issue.overrides.map((override, index) => (React.createElement(IssueOverrideComponentList, { key: generateOverrideId(override), rowIndex: index, issueId: issue.id, override: override }))))));
};
export default IssueDetails;
//# sourceMappingURL=IssueDetails.js.map